<template>
    <EventsList />
</template>

<script>
import { defineComponent, ref } from 'vue'
import EventsList from '@/components/EventsList.vue'
import { useStore } from 'vuex'
export default defineComponent({
    name: 'App',
    components: {
        EventsList,
    },
    // eslint-disable-next-line vue/require-prop-types
    props: ['locationKey', 'eventKey', 'months'],
    setup() {
        return {
            componentName: ref('App'),
        }
    },
    async created() {
        const store = useStore()
        await store.dispatch('events/getCategories')

        if (this.locationKey) {
            await store.dispatch('events/updateDefaultLocationFilter', this.locationKey)
        }

        if (this.eventKey) {
            await store.dispatch('events/updateDefaultEventFilter', this.eventKey)
        }

        if (this.months && !isNaN(parseInt(this.months))) {
            await store.dispatch(
                'events/updateDefaultMaxMonthsFilter',
                parseInt(this.months)
            )
        }

        await this.$nextTick()
        await store.dispatch('events/getEventData')
    },
})
</script>

<style scoped></style>
